import dsTokens from "../../../tokens";

export const sampleOptions = [
  { value: "all-classes", label: "Alle Klassen" },
  { value: "3a", label: "3A" },
  { value: "2b", label: "2B" },
  { value: "1a", label: "1A" },
  { value: "1b", label: "1B" },
  { value: "2a", label: "2A" },
  { value: "2c", label: "2C" },
  { value: "3b", label: "3B" },
  { value: "3c", label: "3C" },
  { value: "4a", label: "4A" },
  { value: "4b", label: "4B" },
  { value: "4c", label: "4C" },
  { value: "5a", label: "5A" },
  { value: "5b", label: "5B" },
  { value: "6a", label: "6A" },
];

export const sampleTabs = [
  { key: "overview", label: "Übersicht" },
  { key: "availability", label: "Verfügbarkeit" },
  { key: "qualification", label: "Qualifikation" },
];

export const sampleTableRows = [
  {
    id: "row-1",
    selected: true,
    area: "Mathematik",
    email: "max.mustermann@schule.ch",
    identity: "MaMu",
    entity: "B102",
    count: "18/20",
    status: { label: "OK", status: "success" },
  },
  {
    id: "row-2",
    selected: false,
    area: "Sprachen",
    email: "charlotte.lang@schule.ch",
    identity: "ChLa",
    entity: "1Aa",
    count: "14/18",
    status: { label: "Teilweise", status: "warning" },
  },
  {
    id: "row-3",
    selected: false,
    area: "Naturwissenschaften",
    email: "lukas.meier@schule.ch",
    identity: "LuMe",
    entity: "C204",
    count: "11/20",
    status: { label: "Offen", status: "error" },
  },
  {
    id: "row-4",
    selected: false,
    area: "Vertretungspool",
    email: "pool@schule.ch",
    identity: null,
    entity: null,
    count: "0/12",
    status: { label: "Offen", status: "error" },
  },
];

export const sampleTableAllRows = Array.from({ length: 9 }, (_, groupIndex) =>
  sampleTableRows.map((row, index) => ({
    ...row,
    id: `${row.id}-group-${groupIndex}-${index}`,
  }))
).flat();

export const sampleTableCurrentPage = 1;
export const sampleTablePageSize = 12;
export const sampleTableTotalCount = sampleTableAllRows.length;
export const sampleTablePageCount = Math.max(1, Math.ceil(sampleTableTotalCount / sampleTablePageSize));
export const sampleTableRangeStart =
  sampleTableTotalCount === 0 ? 0 : (sampleTableCurrentPage - 1) * sampleTablePageSize + 1;
export const sampleTableRangeEnd = Math.min(sampleTableCurrentPage * sampleTablePageSize, sampleTableTotalCount);
export const sampleTableDemoRows = sampleTableAllRows.slice(sampleTableRangeStart - 1, sampleTableRangeEnd);
export const sampleTableVisiblePages = Array.from({ length: sampleTablePageCount }, (_, index) => index + 1);

export const buttonVariantCatalog = [
  {
    code: "BTN-01",
    key: "primary",
    label: "Primary",
    usedIn: "genau eine dominante Hauptaktion pro Screen, Dialog oder Toolbar",
    definition: "Brand-filled, inverse Textfarbe, stärkster Glow und klarster CTA im System.",
  },
  {
    code: "BTN-02",
    key: "outlined",
    label: "Outlined Primary",
    usedIn: "sekundäre, aber weiterhin wichtige Aktion mit Primärbezug",
    definition: "Weisse Fläche, brandige Border und subtiler Glow für wichtige, aber nicht dominante Actions.",
  },
  {
    code: "BTN-03",
    key: "neutral",
    label: "Neutral",
    usedIn: "normale Hilfsaktionen wie Schliessen, Öffnen, Abbrechen oder Ansehen",
    definition: "Ruhiger Standardbutton mit weisser Fläche und primärer Textlesbarkeit.",
  },
  {
    code: "BTN-04",
    key: "muted",
    label: "Muted",
    usedIn: "Utility-Aktionen in Toolbars, Tabellen und sekundären Action-Reihen",
    definition: "Wie Neutral, aber mit text-secondary für bewusst leisere Gewichtung.",
  },
  {
    code: "BTN-05",
    key: "error",
    label: "Error",
    usedIn: "destruktive oder kritische Aktionen wie Löschen, Entfernen oder endgültiges Zurücksetzen",
    definition: "Wie Primary aufgebaut, aber mit Error-Farben und Error-Effekten für klare Risikosignale.",
  },
];

export const buttonSizeCatalog = [
  {
    key: "xs",
    label: "XS",
    height: `${dsTokens.control.heightXs}px`,
    usedIn: "dichte Inline-Aktionen, Meta-Zeilen",
  },
  {
    key: "sm",
    label: "SM",
    height: `${dsTokens.control.heightSm}px`,
    usedIn: "Cards",
  },
  {
    key: "md",
    label: "MD",
    height: `${dsTokens.control.heightMd}px`,
    usedIn: "Pages, Dialogs",
  },
  {
    key: "lg",
    label: "LG",
    height: `${dsTokens.control.heightLg}px`,
    usedIn: "Formulare",
  },
];
